var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_2559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 4.25C18 4.94031 17.4404 5.5 16.75 5.5C16.7423 5.5 16.7358 5.49604 16.7281 5.49592L15.1493 14.1803C15.0625 14.6531 14.65 15 14.1657 15H3.83442C3.3513 15 2.93692 14.6544 2.85067 14.1791L1.27224 5.49687C1.26442 5.49687 1.25786 5.5 1.22192 5.5C0.531611 5.5 -0.0280762 4.94031 -0.0280762 4.25C-0.0280762 3.55969 0.559736 3 1.22192 3C1.88411 3 2.47192 3.55969 2.47192 4.25C2.47192 4.53119 2.36189 4.77781 2.20514 4.98656L5.00608 7.22719C5.50327 7.625 6.24045 7.46294 6.52514 6.89344L8.32514 3.29344C7.97192 3.07312 7.72192 2.69813 7.72192 2.25C7.72192 1.55969 8.30942 1 9.00005 1C9.69067 1 10.2219 1.55969 10.2219 2.25C10.2219 2.69813 9.97308 3.07313 9.6188 3.29375L11.4188 6.89375C11.7035 7.46313 12.441 7.625 12.9379 7.2275L15.7388 4.98688C15.6094 4.77813 15.5 4.50312 15.5 4.25C15.5 3.55938 16.0594 3 16.75 3C17.4407 3 18 3.55938 18 4.25Z",
    fill: "#FCB739"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_2559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.c44cbc7617ee28f7dbd3c9cf5d2d87f1.svg";
export { ForwardRef as ReactComponent };